import cn from 'classnames';
import React, {useCallback} from 'react';
import ReactDropzone from 'react-dropzone';
import {FormattedMessage} from 'react-intl';
import Folder from '@material-ui/icons/Folder';
import {Typography, Grid, Box} from '@material-ui/core';

import {PADDING_SIZE} from './DropAreaMap';

import './DropArea.scss';

type DropAreaProps = {
  accept?: string | string[];
  maxSize?: number;
  message?: string;
  disabled?: boolean;
  className?: string;
  size?: keyof typeof PADDING_SIZE;

  onChange?: (files: File[]) => void;
  onDropRejected?: (files: File[]) => void;
};

function DropArea({
  accept,
  maxSize,
  message,
  className,
  size = 'xs',
  disabled = false,

  onChange,
  onDropRejected,
}: DropAreaProps) {
  const onDrop: DropAreaProps['onChange'] = useCallback(
    (files: File[]) => {
      if (onChange) {
        onChange(files);
      }
    },
    [onChange]
  );

  return (
    <Box
      p={1}
      id="drop-area"
      data-testid="drop-area"
      className={cn(
        'droparea-container',
        disabled && 'droparea-container--disabled',
        className
      )}
    >
      <Box className="droparea-inner-container" p={String(PADDING_SIZE[size])}>
        <ReactDropzone
          onDrop={onDrop}
          accept={accept}
          maxSize={maxSize}
          onDropRejected={onDropRejected}
        >
          {({getRootProps, getInputProps}) => (
            <div {...getRootProps()} className="hit-area">
              <input {...getInputProps()} disabled={disabled} />

              <Typography variant="subtitle1" color="textSecondary" align="center">
                {message || <FormattedMessage id="storage.dragAndDrop" />}
              </Typography>

              <Box>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <Typography
                      variant="subtitle2"
                      color={disabled ? 'textSecondary' : 'primary'}
                      component="span"
                    >
                      <FormattedMessage id="storage.clickToBrowse" />
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Folder color={disabled ? 'disabled' : 'primary'} fontSize="small" />
                  </Grid>
                </Grid>
              </Box>
            </div>
          )}
        </ReactDropzone>
      </Box>
    </Box>
  );
}

export default DropArea;
